/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import moment from 'moment';
import { ChatbotAssistantState, ChatbotAssistantTypes, CurrentUserChatMessageTypes } from './types';

const DEFAULT_REQUEST_STATE = {
  loading: false,
  loaded: false,
  error: false,
};

const INITIAL_STATE: ChatbotAssistantState = {
  chatbot_assistant: {
    current_chat_id: null,
    user_chats: [],
    user_chat_messages: {},
    current_chat_messages: [],
  },
  request: {
    create_user_chat_message: DEFAULT_REQUEST_STATE,
    fetch_user_chat_message: DEFAULT_REQUEST_STATE,
    update_user_chat_message: DEFAULT_REQUEST_STATE,
    fetch_user_chats: DEFAULT_REQUEST_STATE,
    create_user_chat: DEFAULT_REQUEST_STATE,
  },
};

const reducer: Reducer<ChatbotAssistantState> = (
  state = INITIAL_STATE,
  { type, result, assistant_user_chat_id, content, message_id, rating, is_current_chat },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHAT_MESSAGES_REQUEST:
        draft.request.fetch_user_chat_message = {
          ...INITIAL_STATE.request.fetch_user_chat_message,
          loading: true,
        };
        break;

      case ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHAT_MESSAGES_SUCCESS:
        draft.chatbot_assistant.user_chat_messages[assistant_user_chat_id] =
          result.data.assistant_user_chat_messages;
        if (is_current_chat)
          draft.chatbot_assistant.current_chat_messages = result.data.assistant_user_chat_messages;
        draft.request.fetch_user_chat_message = {
          ...INITIAL_STATE.request.fetch_user_chat_message,
          loaded: true,
        };
        break;

      case ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHAT_MESSAGES_FAILURE:
        draft.request.fetch_user_chat_message = {
          ...INITIAL_STATE.request.fetch_user_chat_message,
          error: true,
        };
        break;

      case ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_MESSAGE_REQUEST:
        draft.request.create_user_chat_message = {
          ...INITIAL_STATE.request.create_user_chat_message,
          loading: true,
        };
        const userMessage: CurrentUserChatMessageTypes = {
          id: null,
          rating: null,
          content: content as string,
          created_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          updated_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          role: 'user',
        };

        draft.chatbot_assistant.current_chat_messages = [
          ...state.chatbot_assistant.current_chat_messages,
          userMessage,
        ];
        break;

      case ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_MESSAGE_SUCCESS:
        const botMessage: CurrentUserChatMessageTypes = {
          id: result.data.bot_sent_message.id,
          rating: null,
          content: result.data.bot_sent_message.content,
          created_at: result.data.bot_sent_message.created_at,
          updated_at: result.data.bot_sent_message.updated_at,
          role: result.data.bot_sent_message.role,
        };

        draft.chatbot_assistant.current_chat_id = result.data.assistant_user_chat.id;
        draft.chatbot_assistant.current_chat_messages = [
          ...state.chatbot_assistant.current_chat_messages,
          botMessage,
        ];

        draft.request.create_user_chat_message = {
          ...INITIAL_STATE.request.create_user_chat_message,
          loaded: true,
        };
        break;

      case ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_MESSAGE_FAILURE:
        draft.request.create_user_chat_message = {
          ...INITIAL_STATE.request.create_user_chat_message,
          error: true,
        };
        break;

      case ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHATS_REQUEST:
        draft.request.fetch_user_chats = {
          ...INITIAL_STATE.request.fetch_user_chats,
          loading: true,
        };
        break;

      case ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHATS_SUCCESS:
        draft.chatbot_assistant.user_chats = result.data.assistant_user_chat;

        draft.request.fetch_user_chats = {
          ...INITIAL_STATE.request.fetch_user_chats,
          loaded: true,
        };
        break;

      case ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHATS_FAILURE:
        draft.request.fetch_user_chats = { ...INITIAL_STATE.request.fetch_user_chats, error: true };
        break;

      case ChatbotAssistantTypes.UPDATE_SELECTED_CHAT_ID:
        draft.chatbot_assistant.current_chat_id = assistant_user_chat_id;
        draft.chatbot_assistant.current_chat_messages =
          INITIAL_STATE.chatbot_assistant.current_chat_messages;
        break;

      case ChatbotAssistantTypes.UPDATE_ASSISTANT_USER_CHAT_MESSAGE_REQUEST:
        draft.request.update_user_chat_message = { ...DEFAULT_REQUEST_STATE, loading: true };
        break;

      case ChatbotAssistantTypes.UPDATE_ASSISTANT_USER_CHAT_MESSAGE_SUCCESS:
        const updatedMessageIndex = state.chatbot_assistant.current_chat_messages.findIndex(
          (message) => message.id === message_id,
        );

        if (updatedMessageIndex)
          draft.chatbot_assistant.current_chat_messages[updatedMessageIndex].rating = rating;

        draft.request.update_user_chat_message = { ...DEFAULT_REQUEST_STATE, loaded: true };
        break;

      case ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_REQUEST:
        draft.request.create_user_chat = {
          ...DEFAULT_REQUEST_STATE,
          loading: true,
        };
        break;

      case ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_SUCCESS:
        draft.chatbot_assistant.current_chat_id = result.data.id;
        draft.request.create_user_chat = {
          ...DEFAULT_REQUEST_STATE,
          loaded: true,
        };

        break;

      case ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_FAILURE:
        draft.request.create_user_chat = {
          ...DEFAULT_REQUEST_STATE,
          error: true,
        };
        break;

      case ChatbotAssistantTypes.UPDATE_ASSISTANT_USER_CHAT_MESSAGE_FAILURE:
        draft.request.update_user_chat_message = { ...DEFAULT_REQUEST_STATE, error: true };
        break;

      default:
        break;
    }
  });
};

export default reducer;
